import OrganizerShowcase from "../components/OrganizerShowcase";

export default function ChallengesOrganizersPage() {
  return <OrganizerShowcase kind="challenges" />;
}
